import styled from "@emotion/styled";

export const SubCategoryWrapper = styled.div`
    .sb-title {
        font-weight: 500;
        font-size: 1rem;
        margin-bottom: 8px;

        &.sb-manual {
            color: #666;
        }
    }

    .sb-title-big {
        margin-bottom: 4px;
    }

    .sb-list {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .sb-item {
        display: block;
        text-transform: initial;
        font-weight: 400;
        line-height: 1.92;
        margin-bottom: 8px;
        font-size: 0.92rem;
        color: #666;
        text-decoration: none;
        cursor: pointer;

        &.sb-link {
            text-decoration: underline;
            font-weight: 500;
        }

        &:hover {
            color: #000;
        }
    }

    .sb-item-big {
        font-size: 1rem;
        line-height: 1.79;
        margin-bottom: 0;
    }
`;
